import { z } from 'zod';

import { FormField } from './constants';
import { FormValues } from './types';

export const formValidationSchema = z.object({
  [FormField.email]: z.email('Should be valid email'),
  [FormField.confirmation]: z.boolean().optional(),
}) satisfies z.ZodType<FormValues>;
